import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { UzurvDirectivesModule, UzurvPipesModule } from '@uzurv/core';
import { TransitProgramDriverSearchComponent } from './transit-program-driver-search/transit-program-driver-search.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatListModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatTableModule,
    RouterModule,
    UzurvPipesModule,
    UzurvDirectivesModule
  ],
  declarations: [TransitProgramDriverSearchComponent],
  exports: [TransitProgramDriverSearchComponent]
})
export class TransitProgramModule {}
